<template>
  <rhcn-drawer
    @on-close="onClose"
    v-loading="loading">
    <div class="drawer-form exchange-form" style="width: 637px;">
      <div>
        <rhcn-step :steps="steps" :active="1"></rhcn-step>
      </div>
      <div class="exchange-review-contents">
        <div class="title">{{$t('message.exchange.payoutInfo')}}</div>
        <div class="item">
          <el-image style="width: 30px;" :src="getCurrencyImage(form.sellCurrency) ? require(`@/assets/images/currency/${form.sellCurrency}.png`) : ''"></el-image>
          <div class="text">
            <div class="name">{{$t('message.exchange.youSell')}}</div>
            <div class="amount ">{{form.sellAmount}} {{form.sellCurrency}}</div>
          </div>
        </div>
        <div class="item">
          <div class="item-img">
            <div class="close-icon">
              <span class="el-icon-close"></span>
            </div>
          </div>
          <div class="text">
            <div class="name">{{$t('message.exchange.guaranteedRate')}}</div>
            <div class="amount">{{form.convRate}} {{form.sellCurrency}}/{{form.buyCurrency}} {{$t('message.exchange.guaranteedRate')}} ({{refreshTime}}s)
              <el-button class="refresh-btn" type="text" @click="refresh" v-if="refreshTime <= 0">{{$t('message.exchange.refresh')}}</el-button>
            </div>
          </div>
        </div>
        <div class="item">
          <el-image style="height: 30px;" :src="getCurrencyImage(form.buyCurrency) ? require(`@/assets/images/currency/${form.buyCurrency}.png`) : ''"></el-image>
          <div class="text">
            <div class="name">{{$t('message.exchange.youBuy')}}</div>
            <div class="amount">{{form.buyAmount}} {{form.buyCurrency}}</div>
          </div>
        </div>
        <div class="item">
          <el-image style="height: 30px;" :src="require('@/assets/images/date.png')"></el-image>
          <div class="text">
            <div class="name">{{$t('message.exchange.deliveryDate')}}</div>
            <div class="amount">{{form.deliverDate}}</div>
          </div>
        </div>
      </div>
      <div class="margin-top-40">
        <el-button :disabled="refreshTime <= 0" style="width:100%;" type="primary" @click="submit">{{$t('message.exchange.continue')}}</el-button>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import RhcnStep from '@/components/step/index.vue';
import { getCurrencyImage } from '@/utils/tools/currency';
import ExchangeService from '@/views/wallet/api/exchange';

export default {
  components: { RhcnDrawer, RhcnStep },
  data() {
    return {
      loading: true,
      form: {
        sellCurrency: this.$route.query.sell,
        buyCurrency: this.$route.query.buy,
        amount: this.$route.query.amount,
        buyAmount: '',
        deliverDate: this.$route.query.date,
        convRate: '',
        id: '',
        buySell: this.$route.query.buySell,
      },
      refreshTime: 0,
      steps: [{
        title: 'message.exchange.amount',
        handler: () => {
          this.$router.push({
            path: '/wallet/exchange/add/amount',
          });
        },
      }, {
        title: 'message.exchange.review',
      }],
    };
  },
  created() {
    this.lockRate();
  },
  methods: {
    onClose() {
      this.$router.push({
        path: '/wallet/exchange',
      });
    },
    refresh() {
      this.lockRate();
    },
    submit() {
      this.loading = true;
      ExchangeService.addExchange(this.form.id).then((res) => {
        this.loading = false;
        ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
        this.$router.push({
          path: '/wallet/exchange',
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    lockRate() {
      this.loading = true;
      ExchangeService.getLockExchangeRate(this.form).then((res) => {
        this.loading = false;
        this.form.buyAmount = res.buyAmount;
        this.form.convRate = res.convRate;
        this.form.sellAmount = res.sellAmount;
        this.form.id = res.id;
        // this.refreshTime = Math.floor(((new Date(res.quoteTime)).getTime() - (new Date()).getTime()) / 1000);
        this.refreshTime = 30;
        const timer = setInterval(() => {
          this.refreshTime -= 1;
          if (this.refreshTime <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      }).catch(() => {
        this.loading = false;
      });
    },
    getCurrencyImage,
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.exchange-form {
  margin-top: -68px;
  .exchange-review-contents {
    padding: 20px 20px 32px;
    background: $color-default;
    margin-top: 60px;
    .title {
      font-size: 14px;
      font-weight: 800;
      line-height: 19px;
      padding-left: 10px;
    }
    .item {
      background: $color-white;
      border-radius: 4px;
      padding: 14px 20px;
      margin-top: 15px;
      display: flex;
      align-items: center;
      .item-img {
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        .close-icon {
          width: 23px;
          height: 23px;
          background: $color-default;
          text-align: center;
          line-height: 23px;
          border-radius: 50%;
          .el-icon-close {
            font-weight: bold;
            line-height: 23px;
          }
        }
      }
      .text {
        margin-left: 20px;
        .name {
          font-size: 14px;
          font-weight: normal;
          line-height: 19px
        }
        .amount {
          font-size: 14px;
          font-weight: bold;
          line-height: 17px;
          margin-top: 6px;
          &.blue {
            color: $color-text-default-button;
          }
          .refresh-btn {
            margin-left: 20px;
            padding: 0;
            color: $color-success;
            &.is-disabled {
              border: 0;
              color: #D1D1D1;
            }
            &:hover {
              background: none;
            }
          }
        }
      }
    }
  }
}
</style>
